<div class="counter">
  <label>number of contacts:</label> {{count}}
</div>
